var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-select", {
    ref: _vm.id,
    attrs: {
      id: _vm.id,
      "data-cy": _vm.dataCy,
      name: _vm.name,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      items: _vm.items,
      "error-messages": _vm.errorMessages,
      label: _vm.label,
      required: _vm.required,
      outlined: _vm.outlined,
      dense: _vm.dense,
      readonly: _vm.readonly,
      "return-object": _vm.returnObject,
      disabled: _vm.disabled,
      "hide-details": _vm.hideDetails,
      "append-icon": _vm.appendIcon,
      "menu-props": _vm.menuProps,
      "single-line": _vm.singleLine,
      value: _vm.value,
      "item-disabled": _vm.itemDisabled,
      placeholder: _vm.placeholder,
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item, on, attrs }) {
          return [
            _c(
              "v-list-item",
              _vm._g(
                _vm._b(
                  {
                    attrs: {
                      dense: "",
                      id: _vm.generateIdentifer(item),
                      tabindex: _vm.items.indexOf(item),
                    },
                  },
                  "v-list-item",
                  attrs,
                  false
                ),
                on
              ),
              [
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", [
                      _vm._v(_vm._s(_vm.findDisplayName(item))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }